/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignPipelineConfigDestroyStage } from '../../axios/campaignPipelineConfigDestroyStage'
import type {
	CampaignPipelineConfigDestroyStageError,
	CampaignPipelineConfigDestroyStagePathParams,
	CampaignPipelineConfigDestroyStageQueryParams,
	CampaignPipelineConfigDestroyStageResponse,
} from '../../types/CampaignPipelineConfigDestroyStage'

export const campaignPipelineConfigDestroyStageMutationKey = () =>
	[{ url: '/campaigns/:campaign/pipeline-config/stages/:stageId' }] as const

export type CampaignPipelineConfigDestroyStageMutationKey = ReturnType<
	typeof campaignPipelineConfigDestroyStageMutationKey
>

export type CampaignPipelineConfigDestroyStageVariables = {
	campaign: CampaignPipelineConfigDestroyStagePathParams['campaign']
	stageId: CampaignPipelineConfigDestroyStagePathParams['stageId']
	params: CampaignPipelineConfigDestroyStageQueryParams
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignPipelineConfigController.php CampaignPipelineConfigController::destroyStage */
export function useCampaignPipelineConfigDestroyStage<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignPipelineConfigDestroyStageResponse,
		AxiosError<CampaignPipelineConfigDestroyStageError>,
		CampaignPipelineConfigDestroyStageVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignPipelineConfigDestroyStageMutationKey(),
		mutationFn: ({ campaign, stageId, params }: CampaignPipelineConfigDestroyStageVariables) =>
			campaignPipelineConfigDestroyStage(campaign, stageId, params, config).then(res => res.data),
		...options,
	})
}
